import {useTheme} from '@mui/material';
import FormSelectField from '../../components/fields/FormSelectField';
import {observer} from 'mobx-react';
import FilledTextButton from '../../components/buttons/FilledTextButton';
import LineTextButton from '../../components/buttons/LineTextButton';
import * as React from 'react';
import FormTextAreaField from '../../components/fields/FormTextAreaField';
import ButtonsContainer from "../../components/medicalConsultationStepsComponents/ButtonsContainer";
import StepsMainContainer from "../../components/medicalConsultationStepsComponents/StepsMainContainer";
import {ScreenTitleBar} from "../../components/ScreenTitleBar";

function SymptomsStep({form, onBack, onContinue}) {
  const theme = useTheme();
  const style = styles(theme);

  const symptomsForm = () => {
    return (
      <section style={style.formContainer}>
        <div style={style.rowContainer}>
          <FormTextAreaField label='¿Cuáles son los síntomas?' field={form.getFieldByName('symptoms')}/>
        </div>
        <div style={style.rowContainer}>
          <FormSelectField label="¿Hace cuánto presenta los síntomas?" field={form.getFieldByName('appearedDaysAgo')}/>
        </div>
      </section>
    )
  }

  return (
    <StepsMainContainer>

      <ScreenTitleBar title={'Motivo de la consulta'} showBackButton={false}/>

      {symptomsForm()}

      <ButtonsContainer>
        <LineTextButton label="Volver" light onClick={onBack}/>
        <FilledTextButton label="Continuar" disabled={!form.isValid} onClick={onContinue}/>
      </ButtonsContainer>
    </StepsMainContainer>
  );

}

export default observer(SymptomsStep);

const styles = () => ({
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '10px',
    width: '70%',
  }
});